import { Avatar, Grid, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { PurpleClose } from 'Images';
import { useEffect } from 'react';
import { isSafari } from 'react-device-detect';

interface IProps {
  onClose: () => void;
  requestNumber?: string;
  title?: string;
}

export const DialogTitleContent = (props: IProps) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);

  useEffect(() => {
    document.getElementById('dialog-title')?.focus();
  }, []);

  return (
    <Grid
      container
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      sx={{ height: '100%' }}
      mb={2}
    >
      <Typography variant='h2' component='h2' tabIndex={0} id='dialog-title'>
        {props.title || dictionary.orderSummaryDialog.title}
      </Typography>

      {isDesktop && (
        <Avatar
          role={'button'}
          component={'button'}
          alt={dictionary.orderSummaryDialog.closeDialog}
          src={PurpleClose}
          onClick={props.onClose}
          sx={{
            cursor: 'pointer',
            alignSelf: isDesktop ? '' : 'flex-start',
            top: !isDesktop && isSafari ? '30px' : '',
            border: 'none',
            background: 'transparent',
            width: '40px',
            height: '40px',
            padding: 0,
          }}
        />
      )}
    </Grid>
  );
};
